module.exports = __webpack_public_path__ + "static/media/36-12.1764e14d.mp3";